import React, { useState } from "react";
import ConfirmRunModal from "./ConfirmRunModal";

export default function StartButton({ period, onStart, disabled }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    setBusy(true);
    try {
      await onStart();
      setModalOpen(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        className="bfr-run-button"
        onClick={() => setModalOpen(true)}
        disabled={disabled}
      >
        Run Now
      </button>
      {modalOpen && (
        <ConfirmRunModal
          period={period}
          onConfirm={handleConfirm}
          onCancel={() => setModalOpen(false)}
          busy={busy}
        />
      )}
    </>
  );
}
